<template>
  <div class="report-cont">
    <div class="ongoing-cont">
      <img class="ongoing-img" src="@/assets/images/ongoing_img.png">
      <span class="span-txt">体测进行中～</span>
      <div class="btn-wrap">
        <el-button type="primary" class="update-btn" @click="handleFetchDetail">刷新</el-button>
        <el-button type="primary" class="update-btn" @click="handleReBodyTest">重做动作</el-button>
        <el-button type="primary" class="update-btn" @click="handleStopBodyTest">终止体测</el-button>
      </div>
    </div>
    <Dialog v-if="dialogShow" v-model="dialogShow" :information="information" @submit-success="dialogSuccess" />
    <Dialog v-if="stopDialogShow" v-model="stopDialogShow" :information="stopInfo" @submit-success="stopSuccess" />
  </div>
</template>

<script>
import { reBodyTest, stopBodyTest } from "@/api/stores";
import Dialog from "@/components/Dialog";
export default {
  name: "CervixIn",
  components: { Dialog },
  data() {
    return {
      dialogShow: false,
      information: {
        operation: "submit",
        icon: "warn",
        subTitle: "是否重试当前动作, 确定后当前动作完成后自动重做当前动作",
      },
      stopDialogShow: false,
      stopInfo: {
        operation: "submit",
        icon: "warn",
        subTitle: "是否终止体测, 确定后当前动作完成后自动退出当前体测",
      },
    };
  },
  async created() {
    await this.handleFetchDetail();
  },
  methods: {
    handleFetchDetail() {
      if (this.$route.query.id) {
        this.$Api.stores.fetchQuestionDetail(this.$route.query.id).then(res => {
          if ((res.status && res.status === 3) || res.status === 4) {
            if (this.$parent && this.$parent.handleEmitNavIndex) {
              this.$parent.handleEmitNavIndex("Report");
            }
          }
        });
      }
    },
    handleReBodyTest() {
      this.dialogShow = true;
    },
    handleStopBodyTest() {
      this.stopDialogShow = true;
    },
    dialogSuccess() {
      if (this.$route.query.id) {
        reBodyTest(this.$route.query.id)
          .then(res => {
            this.$message.success("已成功提交重做申请");
          })
          .catch(_err => {
            this.$message.error("系统异常，请稍后再试");
          });
      } else {
        this.$message.warning("请稍后再试");
      }
    },
    stopSuccess() {
      if (this.$route.query.id) {
        stopBodyTest(this.$route.query.id)
          .then(res => {
            this.$message.success("已成功提交终止申请");
          })
          .catch(_err => {
            this.$message.error("系统异常，请稍后再试");
          });
      } else {
        this.$message.warning("请稍后再试");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.report-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ongoing-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .ongoing-img {
    width: calc(43px * 0.75);
  }
  .span-txt {
    margin: calc(18px * 0.75) auto calc(30px * 0.75);
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: normal;
    font-size: calc(18px * 0.75);
    line-height: calc(30px * 0.75);
    text-align: center;
    color: #494949;
  }
  .btn-wrap {
    display: flex;
    flex-direction: column;
    .update-btn {
      width: calc(230px * 0.75);
      height: calc(64px * 0.75);
      & + .update-btn {
        margin-left: unset;
        margin-top: 10px;
      }
    }
  }
}
</style>
